import { ExternalIntegrationCard } from '../ExternalIntegrationCard/ExternalIntegrationCard'
import { ExternalIntegrationEnum, WixIntegration } from 'api/clients/ExternalIntegrationsClient'
import { Wix } from 'blaze-ui/icons/20'
import { Settings } from 'blaze-ui/icons/20'
import { CardButtons } from './CardButtons'
import { useInitiateOauth } from 'hooks/useInitiateOauth'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { useBlogIntegrations } from 'hooks/useBlogIntegrations'
import { useModals } from 'almanac-ui/Modal'
import { WixSettingsModal } from '../WixSettingsModal/WixSettingsModal'
import { Button } from 'blaze-ui/Button'
import Styles from './WixCard.module.scss'

export const WixCard = ({
  integrations = [],
  canConnect,
  isDisconnected = false,
}: {
  integrations?: WixIntegration[]
  canConnect?: boolean
  isDisconnected?: boolean
}) => {
  const { initiateOauth } = useInitiateOauth()
  const { openModal } = useModals()
  const wixEnabled = useFlipperFlag('wix_blog_integration')
  const { getRestrictionMessage } = useBlogIntegrations()

  const restrictionMessage = getRestrictionMessage(ExternalIntegrationEnum.Wix)
  const canConnectWix = canConnect ?? !restrictionMessage
  const isConnected = integrations.length > 0
  const showGearIcon = isConnected && !isDisconnected

  const handleConnect = () => {
    initiateOauth(ExternalIntegrationEnum.Wix)
  }

  const handleConfigureClick = () => {
    if (integrations[0]) {
      openModal(WixSettingsModal, { integration: integrations[0] })
    }
  }

  if (!wixEnabled) return null

  return (
    <div className={Styles.cardWrapper}>
      <ExternalIntegrationCard
        title="Wix"
        description="Connect your Wix blog to publish content directly from Blaze"
        integrations={integrations}
        icon={<Wix size={20} />}
        isDisabled={!canConnectWix}
        isDisconnected={isDisconnected}
        buttons={
          <CardButtons
            onConnect={handleConnect}
            provider={ExternalIntegrationEnum.Wix}
            isConnected={isConnected}
            integration={integrations[0]}
            isDisabled={!canConnectWix}
            tooltipMessage={restrictionMessage || undefined}
            isDisconnected={isDisconnected}
          />
        }
      />
      {showGearIcon && (
        <div className={Styles.gearButtonWrapper}>
          <Button
            variant="tertiary"
            size="xs"
            onPress={handleConfigureClick}
            aria-label="Configure Wix integration"
            frontIcon={Settings}
          />
        </div>
      )}
    </div>
  )
}
